import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__logo">Haadi.</div>

        <div className="footer__social">
          <a href="https://www.linkedin.com/in/haadi-yakubu" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a href="https://github.com/Hardy999" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <i className="fab fa-github"></i>
          </a>
          <a href="https://wa.me/233556387424" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <i className="fab fa-whatsapp"></i>
          </a>
          <a href="mailto:hardyyaqub@gmail.com" aria-label="Email">
            <i className="fas fa-envelope"></i>
          </a>
        </div>

        <p className="footer__credit">
          Designed &amp; Built by Haadi Yakubu · hardyyaqub@gmail.com
          <br />
          Wa, Upper West Region, Ghana · {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}

export default Footer;